import { Button, Text } from "@fluentui/react-components";
import React, { useContext, useEffect, useState } from "react";
import CustomLoader from "../components/CustomLoader";
import ProjectSettings from "../components/ProjectSettings";
import DefaultHoursAdminView from "../components/DefaultHoursAdminView";
import { User } from "../types/types";
import { ApiContext, ICompany } from "../providers/ApiProvider";
import { AppContext } from "../providers/ContextProvider";
import { AlertContext } from "../providers/AlertProvider";
import ErrorMessage from "../components/ErrorMessage";

export default function SettingsTab() {
    const { user, token, versionNumber } = useContext(AppContext);
    const { getCompanies, debugSimulateTokenExpired } = useContext(ApiContext);
    const { errorMsg } = useContext(AlertContext);

    const [companiesList, setCompaniesList] = useState<string[]>([]);
    const [companiesData, setCompaniesData] = useState<ICompany[]>([]);

    useEffect(() => {
        if (token) {
            _getCompanies(token);
        }
    }, [token]);

    const _getCompanies = async (token: string) => {
        try {
            const companies = await getCompanies(token);

            const listOfCompanies: string[] = [];
            companies.forEach((company) => {
                listOfCompanies.push(company.company_name);
            });

            setCompaniesList(listOfCompanies);
            setCompaniesData(companies);
        } catch (error) {
            console.error("Error fetching companies:", error);
        }
    };

    return (
        <>
            {!errorMsg ? (
                <div>
                    {user && token ? (
                        <div className="p-2 sm:p-4 flex flex-col justify-start items-center min-h-full w-full max-w-full overflow-hidden box-border bg-(--theme-bg-1)">
                            <div className="w-full max-w-4xl mx-auto flex flex-col gap-6 p-4 sm:p-6 text-(--colorNeutralForeground1)">
                                <h2 className="text-xl sm:text-2xl md:text-3xl font-semibold">
                                    {`Configure project settings`}{" "}
                                    <Text
                                        className="text-red-600"
                                        weight="semibold"
                                        size={500}
                                        content={`${user.is_project_manager ? "Project Manager" : ""}${user.is_admin ? "Admin" : ""}`}
                                    />
                                </h2>
                                <div>
                                    <ProjectSettings
                                        jwtoken={token}
                                        user={user}
                                        companiesList={companiesList}
                                        companiesData={companiesData}
                                        setMessage={() => {}}
                                        setSuccess={() => {}}
                                    />
                                </div>

                                {user.is_admin && (
                                    <>
                                        <div className="mt-6">
                                            <DefaultHoursAdminView token={token} />
                                        </div>
                                    </>
                                )}

                                <div className="text-xs sm:text-sm text-(--colorNeutralForeground3) mt-4">Version: {versionNumber}</div>

                                {process.env.REACT_APP_ENABLE_TOKEN_DEBUG === "true" && user && token && (
                                    <div className="mt-4">
                                        <Button
                                            appearance="secondary"
                                            onClick={() => void debugSimulateTokenExpired(token)}
                                            className="w-full sm:w-auto"
                                        >
                                            Arm token expiry on next save (debug)
                                        </Button>
                                        <Text size={200} className="block mt-1 text-(--colorNeutralForeground3)">
                                            Dev only: click here, then add or edit an hour in the week table. The next save should renew
                                            the token silently (check the browser console for [debug] messages).
                                        </Text>
                                    </div>
                                )}
                            </div>
                        </div>
                    ) : (
                        <CustomLoader msg="Fetching data..." />
                    )}
                </div>
            ) : (
                <ErrorMessage errorMsg={errorMsg} />
            )}
        </>
    );
}
